import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { observer } from 'mobx-react-lite';
import { useState } from "react";
import commonStyles from './Common.module.css';
import EntitiesDelete from "./EntitiesDelete";
import MarkInactiveModal from "./MarkInactiveModal";
import Spinner from "./spinners/Spinner";
import UnsavedChangesModal from "./UnsavedChangesModal";

function EditControls({ isStateChanged, isUpdateLoading, onUpdate, onCancel, primaryLabel }: IEditControlsProps) {
    const [isUnsavedChangesWindowOpen, setIsUnsavedChangesWindowOpen] = useState(false);

    return (
        <>
            <button className={commonStyles.secondaryButton} disabled={isUpdateLoading} onClick={() => isStateChanged ? setIsUnsavedChangesWindowOpen(true) : onCancel()}>Cancel</button>
            {isUpdateLoading ? (
                <Spinner />
            ) : (
                <button type="submit" className={commonStyles.primaryButton} onClick={() => onUpdate()}>{primaryLabel || "Save"}</button>
            )}
            {isUnsavedChangesWindowOpen && (
                <UnsavedChangesModal
                    onNo={() => setIsUnsavedChangesWindowOpen(false)}
                    onYes={onCancel}
                />
            )}
        </>
    );
}

export default observer(EditControls);

interface IEditControlsProps {
    isStateChanged: boolean;
    isUpdateLoading: boolean;
    onUpdate: () => void;
    onCancel: () => void;
    primaryLabel?: string;
}

export function CreateControls({ isStateChanged, isCreateLoading, onCreate, onCancel }: ICreateControlsProps) {
    const [isUnsavedChangesWindowOpen, setIsUnsavedChangesWindowOpen] = useState(false);

    return (
        <>
            <button className={commonStyles.secondaryButton} onClick={() => isStateChanged ? setIsUnsavedChangesWindowOpen(true) : onCancel()}>Cancel</button>
            {isCreateLoading ? (
                <Spinner />
            ) : (
                <button type="submit" className={commonStyles.primaryButton} onClick={() => onCreate()}>Save</button>
            )}
            {isUnsavedChangesWindowOpen && (
                <UnsavedChangesModal
                    onNo={() => setIsUnsavedChangesWindowOpen(false)}
                    onYes={onCancel}
                />
            )}
        </>
    );
}

interface ICreateControlsProps {
    isStateChanged: boolean;
    isCreateLoading: boolean;
    onCreate: () => void;
    onCancel: () => void;
}

export function DeleteControl({ entityName, isLoading, smallSize, onDelete, onPopupClose }: IDeleteControlProps) {
    const [isDeleteWindowOpen, setIsDeleteWindowOpen] = useState(false);

    const onDeleteClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsDeleteWindowOpen(true);
    };

    const handlePopupClose = () => {
        onPopupClose?.();
        setIsDeleteWindowOpen(false);
    }

    return (
        <>
            {isLoading ? (
                <Spinner />
            ) : (
                <button className={smallSize ? commonStyles.smallButton : commonStyles.button} onClick={onDeleteClick}><DeleteIcon fontSize="small" />{!smallSize && "Delete"}</button>
            )}
            {isDeleteWindowOpen && (
                <EntitiesDelete
                    entityName={entityName}
                    entityCount={1}
                    onCancel={() => handlePopupClose()}
                    onDelete={() => {
                        onDelete()
                        handlePopupClose();
                    }}
                />
            )}
        </>
    );
}

interface IDeleteControlProps {
    entityName: string;
    isLoading: boolean;
    onDelete: () => void;
    smallSize?: boolean;
    onPopupClose?: () => void;
}

export function MarkInactiveControl({ entityName, onMarkInactive }: IMarkInactiveControlProps) {
    const [isMarkInactiveWindowOpen, setIsMarkInactiveWindowOpen] = useState(false);

    return (
        <>
            <button className={commonStyles.button} onClick={() => setIsMarkInactiveWindowOpen(true)}><VisibilityOffIcon fontSize="small" />Mark Inactive</button>
            {isMarkInactiveWindowOpen && (
                <MarkInactiveModal
                    entityName={entityName}
                    onCancel={() => setIsMarkInactiveWindowOpen(false)}
                    onMarkInactive={reason => {
                        onMarkInactive(reason);
                        setIsMarkInactiveWindowOpen(false);
                    }}
                />
            )}
        </>
    );
}

interface IMarkInactiveControlProps {
    entityName: string;
    onMarkInactive: (reason: string) => void;
}